// This is a mess, yes.
// Just using this endpoint since there's currently no separated out endpoint for retrieving self tenant
// /whoami/ should be binned and we should use /users/me/ and /tenants/me/

import { api } from "@/services/api"
import { useQuery } from "@tanstack/vue-query"

type Tenant = {
  name?: string
  includeVat?: boolean
  hasBeepaidGoModule: boolean
}

type WhoAmIResponse = {
  client: Tenant
}

export const retrieveSelfTenant =
  async (): Promise<Tenant> => {
    const { body } =
      await api.get<WhoAmIResponse>("/whoami/")
    return body.client
  }

export const CURRENT_TENANT_QUERY_KEY = "current_tenant"
export const useCurrentTenant = () => {
  const { data, ...queryReturn } = useQuery({
    queryKey: [CURRENT_TENANT_QUERY_KEY],
    queryFn: () => retrieveSelfTenant(),
    retry: false,
  })

  return {
    currentTenant: data,
    ...queryReturn,
  }
}
